import React from "react";
import burger from "../../../media/images/filters/burger.webp";
import chinese from "../../../media/images/filters/chinese.webp";
import dessert from "../../../media/images/filters/dessert.webp";
import drink from "../../../media/images/filters/drink.webp";
import indian from "../../../media/images/filters/indian.webp";
import italian from "../../../media/images/filters/italian.webp";
import nonveg from "../../../media/images/filters/nonveg.webp";
import pizza from "../../../media/images/filters/pizza.webp";
import soup from "../../../media/images/filters/soup.webp";
import veg from "../../../media/images/filters/veg.webp";

const BgSquare = (props) => {
  const { style } = props;
  return (
    <div className="bg-square" style={style}>
      <ul className="circles">
        <li>
          <img src={burger} alt="food" />
        </li>
        <li>
          <img src={chinese} alt="food" />
        </li>
        <li>
          <img src={dessert} alt="food" />
        </li>
        <li>
          <img src={drink} alt="food" />
        </li>
        <li>
          <img src={indian} alt="food" />
        </li>
        <li>
          <img src={italian} alt="food" />
        </li>
        <li>
          <img src={nonveg} alt="food" />
        </li>
        <li>
          <img src={pizza} alt="food" />
        </li>
        <li>
          <img src={soup} alt="food" />
        </li>
        <li>
          <img src={veg} alt="food" />
        </li>
      </ul>
    </div>
  );
};

export default BgSquare;
